import api from "@/shared/services/apiClient";

export const sendingOrgService = {
  getDropdown: async (countryOrigin?: string) => {
    const res = await api.get("/sending-org/dropdown", {
      params: countryOrigin ? { country_origin: countryOrigin } : undefined,
    });
    return res.data;
  },

  /**
   * Fetches the localized dropdown list of visa types.
   * @param lang - The current language code ('en', 'ja', etc.)
   */
  getVisaDropdown: async (lang: string) => {
    const res = await api.get("/sending-org/visa-type", {
      params: { lang },
    });
    return res.data;
  },
};
